export const DOCUMENT_TEMPLATE_INCOME_TYPE = {
    W2: 'W-2',
    SELF_EMPLOYED: 'Self-employed',
    RETIRED: 'Retired',
    BANK_STATEMENT: 'BankStatement',
    DSCR: 'DebtServiceCoverageRatio',
    PROFIT_AND_LOSS: 'PL',
    ASSET_DEPLETION: 'AssetDepletion',
}

export const DOCUMENT_TEMPLATE_INCOME_TYPE_OPTIONS = [
    { label: 'W-2', value: DOCUMENT_TEMPLATE_INCOME_TYPE.W2 },
    {
        label: 'Self-employed',
        value: DOCUMENT_TEMPLATE_INCOME_TYPE.SELF_EMPLOYED,
    },
    { label: 'Retired', value: DOCUMENT_TEMPLATE_INCOME_TYPE.RETIRED },
    {
        label: 'Bank statement',
        value: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    },
    { label: 'DSCR', value: DOCUMENT_TEMPLATE_INCOME_TYPE.DSCR },
    {
        label: 'P & L',
        value: DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    },
    {
        label: 'Asset depletion',
        value: DOCUMENT_TEMPLATE_INCOME_TYPE.ASSET_DEPLETION,
    },
]

const incomeTypeAliases = {
    'w-2': DOCUMENT_TEMPLATE_INCOME_TYPE.W2,
    w2: DOCUMENT_TEMPLATE_INCOME_TYPE.W2,
    'self-employed': DOCUMENT_TEMPLATE_INCOME_TYPE.SELF_EMPLOYED,
    'self employed': DOCUMENT_TEMPLATE_INCOME_TYPE.SELF_EMPLOYED,
    retired: DOCUMENT_TEMPLATE_INCOME_TYPE.RETIRED,
    retirement: DOCUMENT_TEMPLATE_INCOME_TYPE.RETIRED,
    bankstatement: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    'bank statement': DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    personalbankstatement12mo: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    personalbankstatement24mo: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    businessbankstatement12mo: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    businessbankstatement24mo: DOCUMENT_TEMPLATE_INCOME_TYPE.BANK_STATEMENT,
    debtservicecoverageratio: DOCUMENT_TEMPLATE_INCOME_TYPE.DSCR,
    dscr: DOCUMENT_TEMPLATE_INCOME_TYPE.DSCR,
    pl: DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    pl12: DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    pl24: DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    'p & l': DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    'p&l': DOCUMENT_TEMPLATE_INCOME_TYPE.PROFIT_AND_LOSS,
    assetdepletion: DOCUMENT_TEMPLATE_INCOME_TYPE.ASSET_DEPLETION,
    'asset depletion': DOCUMENT_TEMPLATE_INCOME_TYPE.ASSET_DEPLETION,
}

const incomeTypeLabels = DOCUMENT_TEMPLATE_INCOME_TYPE_OPTIONS.reduce(
    (labels, option) => ({ ...labels, [option.value]: option.label }),
    {}
)

export const normalizeDocumentTemplateIncomeTypes = (values) => {
    const normalized = (Array.isArray(values) ? values : [values])
        .map((value) =>
            incomeTypeAliases[String(value || '').trim().toLowerCase()]
        )
        .filter(Boolean)

    return normalized.filter(
        (value, index) => normalized.indexOf(value) === index
    )
}

export const getDocumentTemplateIncomeTypeLabel = (value) =>
    incomeTypeLabels[value] || value || ''

export const getDocumentTemplateIncomeTypeLabels = (values) =>
    normalizeDocumentTemplateIncomeTypes(values).map(
        getDocumentTemplateIncomeTypeLabel
    )
